<script lang="ts">
	import { createEventDispatcher } from 'svelte'

	import ButtonA from '$lib/components/Common/Buttons/ButtonA.svelte'
    import { getSubscriptionIntervalDisplayName } from '$lib/stores/subscription/subscription'
    import type { SubscriptionTableInfo } from '$lib/stores/subscription_table_info/types'


	export let subscriptionTableInfo: SubscriptionTableInfo[] = []
	export let interval = ''
	export let selected = false

	let intervalFlagText = ''
	let intervalFlagStyle = ''

	$: {
		subscriptionTableInfo
		intervalFlagText = getIntervalFlagText(interval)
		intervalFlagStyle = getIntervalFlagStyle(interval)
	}

	const dispatch = createEventDispatcher()

	async function handleIntervalClick() {
		dispatch('interval_selected')
		return
	}

	function getIntervalFlagText(interval: string) {
		// if (interval == 'year') return '(Best Savings)'
		if (interval == 'month') return subscriptionTableInfo[0].monthly_flag_text
		if (interval == 'year') return subscriptionTableInfo[0].yearly_flag_text
		return ''
	}
	function getIntervalFlagStyle(interval: string) {
		let featureStyle = ''
		let bgcolor = ''
		if (interval == 'month') bgcolor = subscriptionTableInfo[0].monthly_flag_bgcolor

		if (interval == 'year') bgcolor = subscriptionTableInfo[0].yearly_flag_bgcolor

		if (bgcolor) {
			featureStyle += 'background-color: ' + bgcolor
		}
		//
		return featureStyle
	}

	function getIntervalDisplayName(interval: string) {
		return getSubscriptionIntervalDisplayName(interval, true)
	}
</script>

<ButtonA
	data-test-id="subscription_button_interval_{interval}"
	class="min-w-[150px] !mx-1 !h-14 {selected ? '!text-black !border-gray-700' : ''}"
	on:click={handleIntervalClick}
>
	<div class="relative">
		{#if intervalFlagText}
			<div class=" grid place-items-center">
				<div
					data-test-id="subscription_button_interval_flag"
					class="absolute -top-5 p-2 bg-gray-400 rounded text-xs font-semibold text-white transform -translate-y-1/2 whitespace-nowrap"
					style={intervalFlagStyle}
				>
					{intervalFlagText}
				</div>
			</div>
		{/if}
		{getIntervalDisplayName(interval)}<br />
	</div>
</ButtonA>
